module.exports = __webpack_public_path__ + "static/media/heart.933b1046.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/BodyView/heart.svg
// module id = 355
// module chunks = 0